export default function Week1724(props) {
    return (
        <div class="card shadow-lg p-6 bg-base-100">
            <div class="card-body space-y-6">
                <img class="object-cover h-72 w-72 m-auto" src="https://dknetwork.draftkings.com/wp-content/uploads/USATSI_25125373.jpg" />

                <h2 class="text-2xl font-bold ">Player Projections Powered by Vegas Player Props - Championship Edition</h2>
                <h2 class=" text-sm pr-8 pl-8">By Sang Han</h2>
                <div class="flex justify-center items-center space-x-4">
                    <button class="btn btn-primary" id="prevBtn" onClick={props.movePastWeek}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <h2 class=" text-sm pr-8 pl-8">January 4, 2024</h2>
                    <button class="btn  btn-disabled" id="nextBtn" onClick={props.moveNextWeek}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
                                <a class="underline" href="https://www.reddit.com/r/fantasyfootball/comments/1hoisvj/vegas_projections_powered_by_vegas_player_props/">
                    Original Reddit Post Link
                </a>
                <p class="text-lg">
                    The beginning and the end.  As one chapter closes, another begins.  The circle of life.  Time passes in the blink of an eye and all of a sudden we're left wondering where it went.  One thing we can all agree on is the impermanence of our lives, indirectly the driving force behind all of our actions.  Circumstances force families to move across the country.  A prospect of a greater life has historically caused individuals to leave behind everything they've known, with inherent risk.  Fantasy football seasons all come to a close, while the thrill of it goes into hibernation for another nine months.
                </p>
                <p class="text-lg">
                    Kings, monarchs, dictatorships.  No matter what, they all eventually crumble to the sands of time.  However, their prowess has been etched into the history books.  Immortal like a Wikipedia page.  Similar to fantasy prowess.  The ethereal entities known as fantasy chips will last beyond your time.  Even after the last time someone utters your name, these monuments persist.  They are testimony to your reign as the fantasy king.
                </p>
                <p class="text-lg">
                    Elevate to fantasy prowess through visiting VegasProjections.com, also known as Andúril, the Flame of the West.  Aragorn wielded this sword to protect mankind from Sauron.  All figures are derived from sportsbook player prop odds, which are financially incentivized to converge upon accuracy.  As time passes, sportsbooks have increasingly more relevant data, then quantitative analysis techniques facilitate that convergence.  We, as the fantasy Reddit community, have been developing this tool since week 10 of the 2023 season, with our own quant techniques applied and requested changes addressed. Top 20 rated skill position players using median projections include:
                </p>
                <p class="text-lg">
                    Jahmyr Gibbs 18.82
                </p>
                <p class="text-lg">
                    Saquon Barkley 18.13
                </p>
                <p class="text-lg">
                    Ja'Marr Chase 17.09
                </p>
                <p class="text-lg">
                    Chase Brown 16.91
                </p>
                <p class="text-lg">
                    Bijan Robinson 15.65
                </p>
                <p class="text-lg">
                    Kyren Williams 15.57
                </p>
                <p class="text-lg">
                    Bucky Irving 15.56
                </p>
                <p class="text-lg">
                    Jonathan Taylor 15.45
                </p>
                <p class="text-lg">
                    Justin Jefferson 15.35
                </p>
                <p class="text-lg">
                    Puka Nacua 15.31
                </p>
                <p class="text-lg">
                    Derrick Henry 15.16
                </p>
                <p class="text-lg">
                    Zach Charbonnet 15.12
                </p>
                <p class="text-lg">
                    Nico Collins 15.12
                </p>
                <p class="text-lg">
                    Mike Evans 15.07
                </p>
                <p class="text-lg">
                    De'Von Achane 14.65
                </p>
                <p class="text-lg">
                    Josh Jacobs 14.26
                </p>
                <p class="text-lg">
                    Joe Mixon 13.89
                </p>
                <p class="text-lg">
                    Brian Thomas 13.88
                </p>
                <p class="text-lg">
                    Amon-Ra St. Brown 13.78
                </p>
                <p class="text-lg">
                    Tyjae Spears 13.42
                </p>
                <p class="text-lg">
                    This week we see that Lamar, Josh Allen, Jayden, and Burrow are in their own S tier.  Baker is the only A tier, paralleled with Sam Darnold as the only B tier.  The next seven quarterbacks are in their own mediocre tier.  Jahmyr is rightfully the new RB king, although Saquon and Chase are also S tier.  Zach Charbonnet rounds out the end of the A tier RBs, as Achane falls and Mixon plummets.  Tyjae is right with James Conner, and Vegas doesn't expect JK Dobbins to have slowed down.  Vegas does not view James Cook and Breece Hall as RB1s.  Brian Thomas has elevated into the A tier of WRs, as Ladd rounds out the WR1s.  Like last week, nothing too surprising about the WR state.  Brock, Kittle, and McBride are S tier, while there is no A tier with Kelce as the only B tier.  Similar to the QBs, the next seven tight ends are in their own mediocre tier.
                </p>
                <p class="text-lg">
                    No new updates this week, due to recovering from fantasy depression from losing in the semi-finals.  Fantasy giveth and taketh.  Also, friendly reminder to remove week 18 from your fantasy leagues, as it is extremely lame to have missing players in a championship due to their real team being too good.  My longtime high school homie league made this change about a decade ago.
                </p>
                <p class="text-lg">
                    This is the championship week of the fantasy season.  This is where legends are made.  You know what to do.  Bring it home.
                </p>
            </div>
        </div>
    );
}
